import { AreaQueryProvider } from "__legacy/queries/areas/AreaQueryProvider";
import { UpdateAreaMutationProvider } from "__legacy/queries/areas/UpdateAreaMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, TechnicalAreaForm } from "./TechnicalAreaForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <AreaQueryProvider variables={{ id }}>
      {({ area }) => (
        <UpdateAreaMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit Scheme Area ${area.name} of ${area.scheme.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../../")}>Back to technical areas</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <TechnicalAreaForm
                  action="update"
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={area}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateAreaMutationProvider>
      )}
    </AreaQueryProvider>
  );
};
